angular.module('mtic')
.service('Firebase', function(
  GLOBAL_API_CONFIG,
  $firebaseArray,
  $firebaseObject,
  $log
){
  var fbApp;
  //Init Firebase
  if(!GLOBAL_API_CONFIG.FIREBASE) {
  	$log.warn("<<<<<<<<< Missing Firebase Configuration Data >>>>>>>>>")
  }
  else{
  	fbApp = firebase.initializeApp(GLOBAL_API_CONFIG.FIREBASE, String(Math.random().toString(36).substr(2,10) + Date.now()));
  }
  return {
  	database: function(){
  		return firebase.database(fbApp)
  	},
  	auth: function(){
  		return firebase.auth(fbApp)
  	},
  	/**
     * Generate a 3-way bound array from firebase
     * @param  {Array<String>}
     * @param  {Object}
     * @return {$firebaseArray}
     */
    to3wBoundArray: function(refPath, options){
      if(!options) {
        options = {};
      }
      var ref = this.database().ref(refPath.join('/'))
      _.forEach(options, function(val, name){
        ref = ref[name](val)
      })
      return $firebaseArray(ref)
    },
    /**
     * Generate a 3-way bound object from firebase
     * @param  {Array<String>}
     * @param  {Object}
     * @return {$firebaseArray}
     */
    to3wBoundObject: function(refPath, options){
      if(!options) {
        options = {};
      }
      var ref = this.database().ref(refPath.join('/'))
      _.forEach(options, function(val, name){
        ref = ref[name](val)
      })
      return $firebaseObject(ref)
    }
  }
})
